import { isFunction, noop } from 'lodash'
import React, { PropsWithChildren, useState } from 'react'
import BsAlert from 'react-bootstrap/Alert'
import { TransitionType } from 'react-bootstrap/helpers'
import styled from 'styled-components'

import { propsToVariant, TPropsToVariant } from '../bootstrapHelper'

const Title = styled.div`
  line-height: 1.1;
  font-size: 1.125rem;
`

export interface IAlert extends TPropsToVariant {
  heading?: string
  header?: string
  title?: string
  content?: string
  onClose?: () => void
  dismissible?: boolean
  noMargin?: boolean
  style?: React.CSSProperties
  closeLabel?: string
  transition?: TransitionType
  show?: boolean
  variant?: string
  button?: React.ReactNode
  className?: string
}

const Alert = (props: PropsWithChildren<IAlert>): React.ReactElement => {
  const {
    children,
    content,
    onClose = noop,
    show = true,
    dismissible,
    heading,
    header,
    noMargin,
    style,
    closeLabel = '',
    transition = false,
    variant,
    button,
    className,
  } = props
  const title = heading || header || props.title

  const [showLocal, setShowLocal] = useState(true)

  const hide = (): void => setShowLocal(false)

  if (!showLocal || (!children && !content)) {
    return <></>
  }

  const handleDismiss = (): void => {
    if (onClose) {
      onClose()
    }

    if (dismissible) {
      hide()
    }
  }

  return (
    <BsAlert
      variant={variant || propsToVariant(props, 'info')}
      onClose={handleDismiss}
      dismissible={isFunction(onClose) || dismissible}
      style={{ ...(style || {}), marginBottom: noMargin ? '0' : '' }}
      closeLabel={closeLabel}
      transition={transition}
      show={show}
      className={className}
    >
      <>
        {title && <Title className="mt-0 mb-1">{title}</Title>}
        <div>{children || content}</div>
        {button && <div className="mt-1">{button}</div>}
      </>
    </BsAlert>
  )
}

export default Alert
